// extracted by mini-css-extract-plugin
module.exports = {"select":"_3T2CajYLDqE-Vj3ffwczfT"};